document.addEventListener('DOMContentLoaded', () => {
  const handlePreviewBadgeClick = (/** @type {MouseEvent} */ event) => {
    const target =
      event.target instanceof HTMLElement
        ? event.target.closest(
            '.jdgm-preview-badge--with-link, .jdgm-preview-badge, .jdgm-prev-badge, .jdgm-prev-badge__stars',
          )
        : null;
    if (!target) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const reviewsWidget = document.querySelector('.jdgm-rev-widg');
    if (reviewsWidget) {
      reviewsWidget.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  document.addEventListener('click', handlePreviewBadgeClick, { capture: true });

  const scrollToReviewsWidget = () => {
    const reviewsWidget = document.querySelector('.jdgm-rev-widg');
    if (reviewsWidget) {
      reviewsWidget.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const handlePaginationClick = (/** @type {MouseEvent} */ event) => {
    const target = event.target instanceof HTMLElement ? event.target.closest('.jdgm-paginate') : null;
    if (!target) return;

    setTimeout(() => {
      scrollToReviewsWidget();
    }, 1000);
  };

  const handleSortDropdownChange = (/** @type {Event} */ event) => {
    const target = event.target;
    if (!(target instanceof HTMLElement) || !target.classList.contains('jdgm-sort-dropdown')) {
      return;
    }

    setTimeout(() => {
      scrollToReviewsWidget();
    }, 1000);
  };

  document.addEventListener('click', handlePaginationClick, { capture: true });
  document.addEventListener('change', handleSortDropdownChange, { capture: true });

  const tooltipTexts = {
    shank: "Measure the inside dimensions of your vehicle's receiver.",
    'towing capacity': 'Maximum weight the hitch assembly can tow.',
    'rise/drop': 'Distance from top pin hole to bottom pin hole.',
    'towing attachments': 'Additional towing attachments to ensure maximum versatility.',
    'pin box connection style':
      'Fifth Wheel King Pin connects using a traditional fifth-wheel hitch in the truck bed. Fifth wheel to gooseneck connection eliminates the need for a fifth-wheel hitch, connecting to a gooseneck ball instead.',
  };

  function injectTooltipIcons() {
    const optionLabels = document.querySelectorAll('.lv-option-label');

    optionLabels.forEach((label) => {
      if (label.querySelector('.tooltip-icon')) {
        return;
      }

      const nameElement = label.querySelector('.lv-option-label__name');
      if (!nameElement) return;

      const nameText = nameElement.textContent.trim().toLowerCase();
      // @ts-ignore - dynamic key access
      let tooltipText = tooltipTexts[nameText];

      if (nameText === 'towing capacity') {
        label.classList.add('lv-option-label--towing-capacity');
      }

      if (nameText.includes('pin') || nameText.includes('pin box')) {
        label.classList.add('lv-option-label--pin-box');
        if (!tooltipText) {
          tooltipText = tooltipTexts['pin box connection style'];
        }
      }

      if (nameText.includes('banner')) {
        label.classList.add('lv-option-label--banner');
      }

      if (nameText.includes('stand')) {
        label.classList.add('lv-option-label--stand');
      }

      if (tooltipText) {
        const tooltipIcon = document.createElement('span');
        tooltipIcon.className = 'tooltip-icon';
        tooltipIcon.setAttribute('data-tooltip-text', tooltipText);
        tooltipIcon.innerHTML =
          '<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none"><path d="M8.125 0C6.51803 0 4.94714 0.476523 3.611 1.36931C2.27485 2.2621 1.23344 3.53105 0.618482 5.0157C0.00352044 6.50035 -0.157382 8.13401 0.156123 9.71011C0.469628 11.2862 1.24346 12.7339 2.37976 13.8702C3.51606 15.0065 4.9638 15.7804 6.5399 16.0939C8.11599 16.4074 9.74966 16.2465 11.2343 15.6315C12.719 15.0166 13.9879 13.9752 14.8807 12.639C15.7735 11.3029 16.25 9.73197 16.25 8.125C16.2477 5.97081 15.391 3.90551 13.8677 2.38227C12.3445 0.85903 10.2792 0.00227486 8.125 0ZM8.125 15C6.76526 15 5.43605 14.5968 4.30546 13.8414C3.17487 13.0859 2.29368 12.0122 1.77333 10.7559C1.25298 9.49971 1.11683 8.11737 1.3821 6.78375C1.64738 5.45013 2.30216 4.22513 3.26364 3.26364C4.22513 2.30216 5.45014 1.64737 6.78376 1.3821C8.11738 1.11683 9.49971 1.25298 10.756 1.77333C12.0122 2.29368 13.0859 3.17487 13.8414 4.30545C14.5968 5.43604 15 6.76525 15 8.125C14.9979 9.94773 14.2729 11.6952 12.9841 12.9841C11.6952 14.2729 9.94773 14.9979 8.125 15ZM9.375 11.875C9.375 12.0408 9.30916 12.1997 9.19195 12.3169C9.07474 12.4342 8.91576 12.5 8.75 12.5C8.41848 12.5 8.10054 12.3683 7.86612 12.1339C7.6317 11.8995 7.5 11.5815 7.5 11.25V8.125C7.33424 8.125 7.17527 8.05915 7.05806 7.94194C6.94085 7.82473 6.875 7.66576 6.875 7.5C6.875 7.33424 6.94085 7.17527 7.05806 7.05806C7.17527 6.94085 7.33424 6.875 7.5 6.875C7.83152 6.875 8.14947 7.0067 8.38389 7.24112C8.61831 7.47554 8.75 7.79348 8.75 8.125V11.25C8.91576 11.25 9.07474 11.3158 9.19195 11.4331C9.30916 11.5503 9.375 11.7092 9.375 11.875ZM6.875 4.6875C6.875 4.50208 6.92999 4.32082 7.033 4.16665C7.13601 4.01248 7.28243 3.89232 7.45374 3.82136C7.62504 3.75041 7.81354 3.73184 7.9954 3.76801C8.17726 3.80419 8.3443 3.89348 8.47542 4.02459C8.60653 4.1557 8.69582 4.32275 8.73199 4.5046C8.76816 4.68646 8.7496 4.87496 8.67864 5.04627C8.60768 5.21757 8.48752 5.36399 8.33335 5.467C8.17918 5.57002 7.99792 5.625 7.8125 5.625C7.56386 5.625 7.32541 5.52623 7.14959 5.35041C6.97378 5.1746 6.875 4.93614 6.875 4.6875Z" fill="#6E6E6E"></path></svg>';

        label.appendChild(tooltipIcon);
      }
    });
  }

  injectTooltipIcons();

  const observer = new MutationObserver(() => {
    injectTooltipIcons();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  /** @type {HTMLDivElement | null} */
  let pinQuantityDisplay = null;
  /** @type {HTMLDivElement | null} */
  let stabilizerBarDisplay = null;
  /** @type {HTMLDivElement | null} */
  let variantDisplaysWrapper = null;
  /** @type {AbortController | null} */
  let currentAbortController = null;

  function createVariantDisplaysWrapper() {
    if (variantDisplaysWrapper) {
      return variantDisplaysWrapper;
    }

    const wrapper = document.createElement('div');
    wrapper.className = 'variant-displays-wrapper';
    wrapper.style.display = 'flex';
    wrapper.style.flexWrap = 'wrap';
    wrapper.style.gap = '8px';
    wrapper.style.marginTop = '16px';
    wrapper.style.alignItems = 'center';
    return wrapper;
  }

  function createPinQuantityDisplay() {
    if (pinQuantityDisplay) {
      return pinQuantityDisplay;
    }

    const display = document.createElement('div');
    display.setAttribute('data-spark', 'b2c-only');
    display.className = 'variant-pin-quantity-display';
    display.style.display = 'none';
    return display;
  }

  function createStabilizerBarDisplay() {
    if (stabilizerBarDisplay) {
      return stabilizerBarDisplay;
    }

    const display = document.createElement('div');
    display.setAttribute('data-spark', 'b2c-only');
    display.className = 'variant-pin-quantity-display';
    display.style.display = 'none';
    return display;
  }

  /**
   * @returns {HTMLElement | null}
   */
  function getVariantPicker() {
    return /** @type {HTMLElement | null} */ (document.querySelector('variant-picker[ref="mainVariantPicker"]'));
  }

  /**
   * @param {HTMLElement | null} variantPicker
   */
  function insertPinQuantityDisplay(variantPicker) {
    if (!variantPicker) return;

    if (!variantDisplaysWrapper || !variantDisplaysWrapper.isConnected) {
      if (variantDisplaysWrapper && !variantDisplaysWrapper.isConnected) {
        variantDisplaysWrapper = null;
        pinQuantityDisplay = null;
        stabilizerBarDisplay = null;
      }

      if (!variantDisplaysWrapper) {
        variantDisplaysWrapper = createVariantDisplaysWrapper();

        if (!pinQuantityDisplay) {
          pinQuantityDisplay = createPinQuantityDisplay();
        }
        if (!stabilizerBarDisplay) {
          stabilizerBarDisplay = createStabilizerBarDisplay();
        }

        variantDisplaysWrapper.appendChild(pinQuantityDisplay);
        variantDisplaysWrapper.appendChild(stabilizerBarDisplay);
        variantPicker.insertAdjacentElement('afterend', variantDisplaysWrapper);
      }
    }
  }

  /**
   * @param {string | number | null | undefined} variantId
   * @returns {Promise<{pinQuantity: string | number | null, stabilizerBar: string | null}>}
   */
  async function fetchVariantData(variantId) {
    const result = { pinQuantity: null, stabilizerBar: null };
    if (!variantId) return result;

    const variantPicker = getVariantPicker();
    if (variantPicker) {
      const pinQuantityScript = variantPicker.querySelector(
        `script[type="application/json"][data-variant-pin-quantity][data-variant-id="${variantId}"]`,
      );
      if (pinQuantityScript) {
        try {
          const data = JSON.parse(pinQuantityScript.textContent);
          if (data.qtyOfPinsIncluded) {
            result.pinQuantity = data.qtyOfPinsIncluded;
          }
          if (data.stabilizerBar) {
            result.stabilizerBar = data.stabilizerBar;
          }
        } catch (e) {}
      }
    }

    if (currentAbortController) {
      currentAbortController.abort();
    }
    currentAbortController = new AbortController();

    try {
      if (!variantPicker) return result;

      const productUrl = /** @type {HTMLElement} */ (variantPicker).dataset.productUrl;
      if (!productUrl) return result;

      const section = variantPicker.closest('.shopify-section');
      const sectionId = section?.id || '';

      const url = new URL(productUrl, window.location.origin);
      url.searchParams.set('variant', variantId.toString());
      if (sectionId) {
        url.searchParams.set('section_id', sectionId);
      }

      const response = await fetch(url.toString(), {
        signal: currentAbortController.signal,
      });

      if (!response.ok) return result;

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const pinQuantityScript = doc.querySelector(
        `variant-picker script[type="application/json"][data-variant-pin-quantity][data-variant-id="${variantId}"]`,
      );

      if (pinQuantityScript) {
        try {
          const data = JSON.parse(pinQuantityScript.textContent);
          if (data.qtyOfPinsIncluded) {
            result.pinQuantity = data.qtyOfPinsIncluded;
          }
          if (data.stabilizerBar) {
            result.stabilizerBar = data.stabilizerBar;
          }
        } catch (e) {}
      }

      return result;
    } catch (error) {
      if (error.name === 'AbortError') {
        return result;
      }
      console.error('Error fetching variant data:', error);
      return result;
    }
  }

  /**
   * @param {string | number | null | undefined} variantId
   */
  async function updatePinQuantityDisplay(variantId) {
    const variantPicker = getVariantPicker();
    if (!variantPicker) return;

    insertPinQuantityDisplay(variantPicker);

    if (!pinQuantityDisplay || !stabilizerBarDisplay || !variantDisplaysWrapper) return;

    const variantData = await fetchVariantData(variantId);

    // Update pin quantity display
    if (variantData.pinQuantity && variantData.pinQuantity.toString().trim() !== '') {
      const quantity = parseInt(variantData.pinQuantity.toString().trim(), 10);
      if (!isNaN(quantity) && quantity > 0) {
        pinQuantityDisplay.textContent = `Includes ${quantity} pin${quantity !== 1 ? 's' : ''} with your order`;
        pinQuantityDisplay.style.display = 'block';
      } else {
        pinQuantityDisplay.style.display = 'none';
      }
    } else {
      pinQuantityDisplay.style.display = 'none';
    }

    // Update stabilizer bar display
    if (variantData.stabilizerBar) {
      const stabilizerBarValue = variantData.stabilizerBar;
      // Handle boolean true, string "True"/"true", or other truthy string values
      const isTrue =
        typeof stabilizerBarValue === 'boolean'
          ? stabilizerBarValue === true
          : String(stabilizerBarValue).toLowerCase().trim() === 'true' ||
            String(stabilizerBarValue).toLowerCase().trim() === '1' ||
            String(stabilizerBarValue).toLowerCase().trim() === 'yes';

      if (isTrue) {
        stabilizerBarDisplay.textContent = 'Stabilizer bars are included with your order';
        stabilizerBarDisplay.style.display = 'block';
      } else {
        stabilizerBarDisplay.style.display = 'none';
      }
    } else {
      stabilizerBarDisplay.style.display = 'none';
    }

    // Show/hide wrapper based on whether any display is visible
    const hasVisibleDisplay =
      pinQuantityDisplay.style.display === 'block' || stabilizerBarDisplay.style.display === 'block';
    variantDisplaysWrapper.style.display = hasVisibleDisplay ? 'flex' : 'none';
  }

  document.addEventListener('variant:update', async (/** @type {CustomEvent} */ event) => {
    const variantId = event.detail?.resource?.id;
    if (variantId) {
      setTimeout(async () => {
        await updatePinQuantityDisplay(variantId);
      }, 50);
    }
  });

  function initializePinQuantityDisplay() {
    const variantPicker = getVariantPicker();
    if (!variantPicker) return;

    insertPinQuantityDisplay(variantPicker);

    const variantScript = variantPicker.querySelector('script[type="application/json"]');
    if (variantScript) {
      try {
        const variantData = JSON.parse(variantScript.textContent);
        if (variantData.id) {
          updatePinQuantityDisplay(variantData.id);
        }
      } catch (e) {}
    }
  }

  setTimeout(initializePinQuantityDisplay, 100);
});
